export default __webpack_public_path__ + "static/media/TimeRunningOut.599333dc.wav";